export default [
  {
    name: "morning",
    start: {
      hours: 8,
      minutes: 0,
    },
    end: {
      hours: 14,
      minutes: 0,
    },
    staffStart: {
      hours: 8,
      minutes: 0,
    },
    staffEnd: {
      hours: 14,
      minutes: 0,
    },
    endAdjust: {},
  },
  {
    name: "afternoon",
    start: {
      hours: 14,
      minutes: 0,
    },
    end: {
      hours: 20,
      minutes: 0,
    },
    staffStart: {
      hours: 14,
      minutes: 0,
    },
    staffEnd: {
      hours: 20,
      minutes: 0,
    },
    handover: {
      label: "Handover with night shift",
      duties: ["hoc"],
      timeAdjust: {
        staffEnd: {
          minutes: 30,
        },
      },
    },
    endAdjust: {},
  },
  {
    name: "day",
    hideFromRota: true,
    start: {
      hours: 8,
      minutes: 0,
    },
    end: {
      hours: 20,
      minutes: 0,
    },
    staffStart: {
      hours: 8,
      minutes: 0,
    },
    staffEnd: {
      hours: 20,
      minutes: 0,
    },
    endAdjust: {},
  },
  {
    name: "night",
    start: {
      hours: 20,
      minutes: 0,
    },
    end: {
      hours: 8,
      minutes: 0,
    },
    staffStart: {
      hours: 20,
      minutes: 30,
    },
    staffEnd: {
      hours: 8,
      minutes: 30,
    },
    handover: {
      label: "Handover with afternoon shift",
      timeAdjust: {
        staffStart: {
          minutes: -30,
        },
      },
    },
    // when we're calculating the endTime, we need to roll over to the next day
    endAdjust: { days: 1 },
  },
];
